
import { useState, useEffect } from 'react';
import { NodeProps, Handle, Position } from '@xyflow/react';
import { Brain } from 'lucide-react';
import { useAgents } from '@/hooks/useAgents';
import { AutomationNodeData } from '@/types/automation';

export const AIAgentNode = ({ data, selected }: NodeProps) => {
  const { agents } = useAgents();
  const [agentName, setAgentName] = useState<string>('AI Agent');
  const nodeData = data as AutomationNodeData;

  useEffect(() => {
    if (nodeData.agentId && agents) {
      const agent = agents.find(a => a.id === nodeData.agentId);
      if (agent) {
        setAgentName(agent.name);
      }
    }
  }, [nodeData.agentId, agents]);

  return (
    <div className={`p-3 rounded-lg shadow-md border border-primary/20 bg-background w-60 ${selected ? 'ring-2 ring-primary' : ''}`}>
      <Handle type="target" position={Position.Top} className="w-3 h-3 bg-primary" />
      
      <div className="flex items-center gap-2 mb-1">
        <div className="bg-primary/10 w-8 h-8 rounded-full flex items-center justify-center">
          <Brain size={16} className="text-primary" />
        </div>
        <div className="font-medium truncate text-sm">{nodeData.label || 'AI Agent'}</div>
      </div>
      
      <div className="text-xs text-muted-foreground mt-2 border-t pt-2">
        <p className="truncate">Agent: <span className="font-medium">{agentName}</span></p>
        {nodeData.prompt && (
          <p className="mt-1 truncate">
            Custom prompt: <span className="italic">{nodeData.prompt.substring(0, 35)}...</span>
          </p>
        )}
      </div>
      
      <Handle type="source" position={Position.Bottom} className="w-3 h-3 bg-primary" />
    </div>
  );
};
